import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NewEmpleoyeActivitiesComponent } from './new-empleoye-activities.component';
import { DxAutocompleteModule, DxButtonModule, DxCheckBoxModule, DxDateBoxModule, DxPopupModule, DxScrollViewModule, DxSelectBoxModule, DxTextAreaModule, DxTextBoxModule } from 'devextreme-angular';
import { MdbGlobalModule } from 'src/app/shared/mdb-global.module';
import { NewCustomerModule } from '../new-customer/new-customer.module';
import { NewServiceSiteModule } from '../new-service-site/new-service-site.module';



@NgModule({
  declarations: [
    NewEmpleoyeActivitiesComponent,
  ],
  imports: [
    CommonModule,
    MdbGlobalModule,
    DxButtonModule,
    DxPopupModule,
    DxScrollViewModule,
    DxDateBoxModule,
    DxAutocompleteModule,
    DxSelectBoxModule,
    DxDateBoxModule,
    DxCheckBoxModule,
    DxTextBoxModule,
    NewServiceSiteModule,
    NewCustomerModule,
    DxTextAreaModule
  ],
  exports: [NewEmpleoyeActivitiesComponent]
})
export class NewEmpleoyeActivitiesModule { }
